import { connect } from "react-redux";
import { selectPlayerProfilePictureName } from "../../balancingSelectors/selectBalancingPictures";
import { IdStyles } from "../../less/IdStyles";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { HOCHudComponent } from "../context-menu/HOCHudComponent";
import { actionOpenOwnPlayerProfile } from "./actionPlayerProfile";
import { ProfilePicture } from "./ProfilePicture";
var mapState = function (state) {
    var profilePictureId = selectPlayerInfo(state).profilePictureId;
    return {
        profilePictureClassName: "hud-player-base-profile-picture",
        profilePictureName: selectPlayerProfilePictureName(profilePictureId),
        profilePictureSize: IdStyles.ProfilePictureSmall,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionOpenOwnPlayerProfile()); },
}); };
export var HudPlayerProfilePicture = connect(mapState, mapDispatch)(HOCHudComponent(ProfilePicture));



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/HudPlayerProfilePicture.tsx
// module id = 2308
// module chunks = 3